import Button from "../button";
import PropTypes from "prop-types";

const Intro = ({ data }) => {
    return (
        <div
            className="intro-section"
            style={{
                backgroundImage: `url(${
                    process.env.PUBLIC_URL + data.backgroundImage
                })`,
            }}
        >
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="slider-content">
                            <p className="text animated delay1">
                                {data.subTitle}
                            </p>
                            <h2
                                className="title animated delay2"
                                dangerouslySetInnerHTML={{ __html: data.title }}
                            />
                            <Button
                                path={process.env.PUBLIC_URL + "/services"}
                                classOption="btn btn-outline-secondary me-3 animated delay1"
                                text="our services"
                            />
                            <Button
                                path={process.env.PUBLIC_URL + "/contact"}
                                classOption="btn btn-danger animated delay2"
                                text="Get a quote"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

Intro.propTypes = {
    data: PropTypes.object,
};

export default Intro;
